<p-dialog
  [header]="getHeader()"
  [(visible)]="visible"
  [style]="{ width: '100%', maxWidth: '650px' }"
  [contentStyle]="{ minHeight: 'auto' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [focusOnShow]="false"
>
  <div class="flex flex-column gap-3">
    <p-messages [(value)]="messages" [enableService]="false" [closable]="false" />

    <eo-form
      #eoForm
      [config]="getFormConfig()"
      (formSubmit)="onSubmit($event)"
      [submitButtonLoading]="isSubmitLoading()"
      [customFormControls]="{
        surgeryCancelReasonOptionID: surgeryCancelReasonOptionID
      }"
    >
      <ng-template
        #surgeryCancelReasonOptionID
        let-formGroup="formGroup"
        let-config="config"
        let-styleClass="styleClass"
      >
        <ng-container [formGroup]="formGroup">
          <eo-dropdown
            [label]="config.label"
            [class]="styleClass"
            [config]="config"
            formControlName="surgeryCancelReasonOptionID"
            optionLabel="optionTypeName"
            optionValue="id"
            placeholder="Επιλέξτε Αιτολογία Ακύρωσης"
            [options]="surgeryCancelReasons ?? []"
            [loading]="isFetchSurgeryCancelReasonsLoading()"
            (change)="updateSurgeryCancelCommentsValidator()"
          />
        </ng-container>
      </ng-template>
    </eo-form>
  </div>
</p-dialog>


